'use client';

interface LoadMoreButtonProps {
  onClick?: () => void;
  label?: string;
}

export default function LoadMoreButton({ onClick, label = 'Load more stories' }: LoadMoreButtonProps) {
  return (
    <div className="text-center mt-8 mb-4">
      <button
        onClick={onClick}
        className="border-2 border-[#0D0D0D] px-8 py-3 font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[13px] text-[#0D0D0D] hover:bg-[#0D0D0D] hover:text-white transition-all duration-150"
      >
        {label}
      </button>
    </div>
  );
}
